import { render, staticRenderFns } from "./AbsencePlanEdit.vue?vue&type=template&id=25c3118a&scoped=true&"
import script from "./AbsencePlanEdit.vue?vue&type=script&lang=js&"
export * from "./AbsencePlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3118a",
  null
  
)

export default component.exports